module.exports = __webpack_public_path__ + "img/audio_00.fa49e231.svg";